import {ShoppingList} from "./ShoppingList";

class CheckoutItem {
    public readonly identifier: string;
    public readonly checkoutRow: HTMLElement;
    private readonly removeButton: HTMLElement|undefined;
    private readonly deletionCheckbox: HTMLInputElement|undefined;

    constructor(identifier: string, checkoutRow: HTMLElement) {
        this.identifier = identifier;
        this.checkoutRow = checkoutRow;
        this.removeButton = checkoutRow.querySelector('[data-plandent-checkout-remove-item]');
        this.deletionCheckbox = checkoutRow.querySelector('[data-plandent-checkout-checkbox]');
    }

    /**
     * Show or hide the checkbox
     *
     * @param show
     */
    public showCheckbox = (show: boolean = false): void => {
        if (this.deletionCheckbox) {
            this.deletionCheckbox.parentElement.style.display = show ? 'block' : 'none';
        }

        if (this.removeButton) {
            this.removeButton.style.display = show ? 'none' : 'block';
        }
    }

    /**
     * Check the checkbox
     */
    public checkCheckbox = (): void => {
        if (!this.deletionCheckbox.checked) {
            return;
        }

        this.deletionCheckbox.checked = true;
    }

    /**
     * Uncheck the checkbox
     */
    public uncheckCheckbox = (): void => {
        if (!this.deletionCheckbox) {
            return;
        }

        this.deletionCheckbox.checked = false;
    }

    /**
     * Is the checkbox checked
     */
    public isChecked = (): boolean => {
        if (!this.deletionCheckbox) {
            return false;
        }

        return this.deletionCheckbox.checked;
    }

    /**
     * Remove item from cart
     */
    public removeItemFromCart(): void {
        ShoppingList.removeItemsFromShoppingList([this.checkoutRow]);
    }

    /**
     * Get or create instance from checkout row
     *
     * @param checkoutRow
     */
    static createInstanceFromCheckoutRow = (checkoutRow: HTMLElement): CheckoutItem => {
        const identifier: string = checkoutRow.dataset.identifier;

        if (identifier) {
            return new CheckoutItem(identifier, checkoutRow);
        } else {
            console.error('No identifier found for checkout row', checkoutRow);
        }

        return null;
    }
}

export default CheckoutItem;
